import * as React from "react";

export const NotificationIcon = (props: any) => (
  <svg
    width={20}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 15h2v2H0v-2h2V8a8 8 0 1 1 16 0v7Zm-2 0V8A6 6 0 1 0 4 8v7h12Zm-9 4h6v2H7v-2Z"
      fill="#2D5BFF"
    />
  </svg>
);
